import { RegistrationConfig } from '../../models/config/registration-config.interface';
import { mockRegistrationFeatures } from './registration-features.mock';

export const mockRegistrationConfig: RegistrationConfig = {
  applianceMaximumAgeInMonths: 96,
  applianceRegistrationLimit: 10,
  commonApi: 'commonApi',
  features: mockRegistrationFeatures,
  modelNumberSearchEnabledBrands: [],
  retailerFieldEnabledBrands: [],
  serializationApi: 'serializationApi',
};
